export function LeadBoardImage() {
    return <img src='/include/images/auth/lead-board.png' alt='lead board' />;
}
